<app-toast></app-toast>
<h1 class="text-5xl font-bold mobile:text-lg">{{ 'auth.onboarding_step_2.set_up_company' | transloco }}</h1>
<p class="mt-1 mobile:text-sm">{{ 'auth.onboarding_step_2.configure_company_details' | transloco }}</p>

<div class="max-w-screen-sm w-full self-center mt-[10vh]">
    <app-labeled-input labelText="{{ 'shared.labels.company.company_name' | transloco }}" [inputId]="'companyName'"
        [inputType]="'text'" [(inputValue)]="companyNameInput" [errorMessage]="companyNameInputError"
        placeholder="{{ 'shared.placeholders.company.company_name' | transloco }}"
        boxHeight="h-[5vh] min-h-[50px] max-h-[70px]"></app-labeled-input>
</div>

<div class="max-w-screen-sm w-full self-center mt-1" *ngIf="atecoCodesLoaded">
    <app-custom-autocomplete labelText="{{ 'auth.ateco_code' | transloco }}"
        placeholder="{{ 'auth.select_ateco_code' | transloco }}" [suggestions]="allAtecoCodes"
        [errorMessage]="industryCodeInputError" [isDisabled]="!atecoCodesLoaded" [labelRenderer]="labelRendererFn"
        [(selectedItem)]="selectedAtecoCode">
    </app-custom-autocomplete>
</div>

<div class="max-w-screen-sm w-full self-center mt-1">
    <app-textarea-input labelText="{{ 'auth.onboarding_step_2.about_us_text' | transloco }}" [inputId]="'aboutUs'"
        [(textValue)]="aboutUsInput" [errorMessage]="aboutUsInputError"
        placeholder="{{ 'auth.onboarding_step_2.about_us_placeholder' | transloco }}"
        boxHeight="h-[10vh] min-h-[100px] max-h-[150px]"></app-textarea-input>
</div>

<div class="max-w-screen-sm w-full mt-8 mb-6">
    <app-primary-button buttonText="{{ 'shared.continue' | transloco }}" [isDisabled]="continueClicked"
        (buttonClick)="continueButtonClick()">
    </app-primary-button>
</div>